export default "__VITE_ASSET__CigpkJ$5__"